<div class="bg-ponder-dark min-h-screen w-full overflow-x-hidden flex flex-col"  style="background: linear-gradient(#343346, #1A1922);">
    <div class="flex flex-col gap-4 p-8 pt-12 pb-12 justify-center">
        <div class="flex justify-center">
            <div class="pt-12 max-w-sm sm:max-w-3xl xl:max-w-5xl grow text-xl sm:text-2xl font-bold font-title text-white text-center">
                Password Recovery
            </div>
        </div>
        <div class="flex justify-center">
            <div class="flex flex-col p-4 pt-0 gap-3 w-[360px] text-base">
                @if (isGettingTemporaryAuth) {
                    <busy-spin [small]="true" [bright]="true"></busy-spin>
                } @else {
                    @if (!authFailed)
                    {
                        <form [formGroup]="recoveryForm" class="flex flex-col gap-3" (submit)="onSubmit()">
                            <div class="text-sm text-faded-70 pb-2 text-center">
                                @if (isGettingTemporaryAuth) {
                                    <busy-spin [small]="true" [bright]="true"></busy-spin>
                                } @else {
                                    {{ emailAddress }}
                                }
                            </div>
                            <!-- Password -->
                            <div class="flex flex-col gap-1">
                                <input 
                                    formControlName="new" 
                                    type="password" 
                                    placeholder="New Password" 
                                    class="bg-ponder rounded-sm shadow-sm p-2 w-full text-white disabled:text-faded-50" 
                                    autocomplete="password"/>
                                <input 
                                    formControlName="confirm" 
                                    type="password" 
                                    placeholder="Confirm Password" 
                                    class="bg-ponder rounded-sm shadow-sm p-2 w-full text-white disabled:text-faded-50" 
                                    autocomplete="password"/>
                                
                                @if (!isPasswordChangeValid && invalidPasswordReasons.length) {
                                    <div class="flex flex-col gap-1 text-xs text-red-600">
                                        @for(reason of invalidPasswordReasons ; track reason) {
                                            <div>{{ reason }}</div>
                                        }
                                    </div>
                                }
                            </div>
                            <!-- Submit -->
                            <button 
                                class="bg-ponder hover:bg-ponder-xlight rounded-sm shadow-sm p-2 w-full min-h-[40px] text-slate-200 hover:text-white disabled:text-faded-50 hover:disabled:bg-ponder"
                                [disabled]="!canSubmit()">
                                @if (!isProcessing) {
                                    Change Password
                                } @else {
                                    <busy-spin [small]="true" [bright]="true"></busy-spin>
                                }
                            </button>
                            <!-- Messages -->
                            @if (processingError) {
                                <div class="p-1 text-xs text-red-600 border-red-600 border rounded">
                                    {{ processingError }}
                                </div>
                            }
                        </form>     
                    } @else {
                        <div class="text-sm text-faded-70 pb-2 text-center">
                            Link has expired.
                        </div>
                    }
                }
            </div>
        </div>
    </div>
</div>